<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex lg12>
          <v-card pa-0>
            <v-toolbar card color="white">
              <v-text-field
              flat
              solo
              prepend-icon="search"
              placeholder="Type something"
              v-model="search"
              hide-details
              ></v-text-field>     
              <!--<v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>-->
              <router-link :to="{path: formPath}">
                  <v-btn color="success" icon dark>
                    <v-icon>add</v-icon>
                  </v-btn>  
              </router-link>              
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table                
                :headers="complex.headers"
                @input="searchTerm"
                :items="complex.items"
                :loading="complex.loading"
                :pagination.sync="complex.options"
                :rows-per-page-items="[{text:'All','value':-1}]"                
                hide-actions
                item-key="id"                                                            
                >
                <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>  
                <template slot="items" slot-scope="props">
                  <td>{{ ((complex.pagination.currentPage-1)*20)+(props.index+1) }}</td>
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.username }}</td>
                  <td>{{ props.item.phone }}</td>
                  <td>
                    <router-link v-if="props.item.userCalon" target="_blank" :to="{path:'/calon/view', query:{id:props.item.id}}" ><v-chip color="green" small dark>{{ 'terdaftar' }}</v-chip></router-link>
                    <v-chip color="orange" small dark v-else>{{ 'belum daftar' }}</v-chip>
                  </td>
                  <td>{{ $moment(props.item.created_at*1000).format('DD/MM/YYYY HH:mm') }}</td>
                  <td class="text-xs-center">
                    <v-btn class="success--text" depressed icon small @click="dialog.status = true; dialog.nomor=props.item.phone;">
                      <v-icon>whatshot</v-icon>
                    </v-btn>
                    <router-link :to="{path:formPath, query: {id: props.item.id}}">
                        <v-btn depressed icon class="primary--text" small>
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </router-link>                          
                  </td>
                </template>
              </v-data-table>
              <v-divider/>
              <div class="text-xs-center pa-2">
                <v-pagination
                  v-model="complex.pagination.currentPage"
                  :length="complex.pagination.pageCount"
                  :total-visible="9"
                ></v-pagination>
              </div>
            </v-card-text>            
          </v-card>
        </v-flex>                           
        </v-layout>
      </v-container>
      <v-dialog v-model="dialog.status" scrollable max-width="300px">        
        <v-card>
          <v-card-title>Kirim Pesan Melalui WA</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px;">
            <v-text-field v-model="dialog.nomor" type="tel" label="Nomor Hp"></v-text-field>
            <v-textarea v-model="dialog.text" label="pesan text"></v-textarea>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" flat @click="dialog.status = false; dialog.nomor=''; dialog.text=''">Close</v-btn>
            <a target="_blank" :href="'https://api.whatsapp.com/send?phone='+dialog.nomor+'&text='+dialog.text"><v-btn color="green darken-1" flat>Kirim</v-btn></a>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import { debounce } from 'lodash'
import Model from '@/apps/admin/models/Calon';   
const  model = new Model();

export default {
    $_veeValidate: {
      validator: 'new'
    },    
    data: () => ({
      dialog : {
        status : false,
        nomor  : '',
        text   : '',
      },
        formPath : '/signup/form',
        search   : '',        
        pagination: {},
        complex  : {
            loading  : true,
            selected: [],
            headers: [
              { text: '#',   value: 'no'  },
              { text: 'ID',   value: 'id'  },
              { text: 'Username', value: 'username'},
              { text: 'Phone', value: 'phone'},    
              { text: 'Status', value: 'calon'},    
              { text: 'Register at', value:'created_at'},
              { text: 'Action', value: '', align:'center' },              
            ],
            term : null,
            items : [],
            options : {},
            pagination:{
              totalCount: null,
              pageCount: 0,
              currentPage: 1,
              perPage: 20
            }
        },
        loadingDownload : false,
        tingkats : [],
    }),
    watch:{
      'dialog.nomor'(newNmr){        
        if(newNmr && newNmr.charAt(0) === '0'){
          this.dialog.nomor = '+62'+newNmr.slice(1); 
        }
      },
      'complex.pagination.currentPage'(newPage){
        this.init(newPage) 
      },
      'complex.options':{
        handler(){
          this.init(this.complex.pagination.currentPage) 
        }, deep:true      
      },
      search(newText){ 
        this.searchTerm(newText);
      }
    },
    mounted(){ 
      //model.tingkats().then(data=>{this.tingkats = data});
      this.init(); 
    },            
    methods: { 
      
        format(tgl) { return this.$moment(tgl).format('DD-MM-YYYY')},
        
        searchTerm:debounce(function (newText) {             
            this.init(this.complex.pagination.currentPage, newText);
        }, 500),

        init(page = 1, term = ''){
            this.complex.loading = true
            let  sortby = this.complex.options.sortBy ? this.complex.options.sortDesc ? 
              '-'+this.complex.options.sortBy : this.complex.options.sortBy : 'id'; 

            const params = {
              perPage: 20,
              page: page,
              expand:'userCalon',
              q: term,
              sort:sortby,              
            }
            this.complex.items = [];
            model.userSignup(params).then(res => {      
                this.complex.items = res.data; 
                this.complex.pagination.pageCount = res.pagination.pageCount;  
                this.complex.loading = false;
            });                                         
        },                     
    }
}
</script>